import React, { useEffect, useState } from 'react'
import { makeStyles, useTheme, SizeProvider, GlobalStyle } from '@seahorse/ui'
import { LineChartOptions } from '@seahorse/charts'
import { Dropdown } from '@seahorse/ui'
import { DateRangePicker } from '@seahorse/ui'
import { fetchNews, fetchChartData } from '../../Utils/Utils'


const InfoFlowTile: React.FunctionComponent = () => {
    const linkStyle = ({
        // maxWidth: "200px", // Set a maximum width for the URL
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "inline-block", // Ensure it's treated as a block-level element for styling
    });

    const theme = useTheme()
    const useStyles = makeStyles({
        container: {
            display: 'grid',
            gridTemplateColumns: '1fr',
            gridTemplateRows: 'auto 1fr',
            gridRowGap: 4,
            width: '100%',
            height: '100%',
            padding: '10px',
        },
        link: linkStyle,
        container1: {
            overflow: 'auto',
            border: '2px solid white ', // Define both border width, style, and color
            padding: '10px',
        }
    })

    const classes = useStyles()

    // const fluidFontSizeClassName = useFluidWidgetFontSizeClassName({ min: 10, max: 12 })

    const colors = {
        Pending: theme.globallink.colors.DataTurquoise[500],
        Ineligible: theme.globallink.colors.DataOrange[500],
        Cleared: theme.globallink.colors.DataPurple[500],
        Rejected: theme.globallink.colors.DataAmber[600],
        Dark: theme.globallink.colors.Grey[1100],
        Light: theme.globallink.colors.Slate[900],
    }

    const [selectedCompany, setSelectedCompany] = useState("Bharatiya Janata Party")
    const [newsArticles, setNewsArticles] = useState([])
    useEffect(() => {
        fetchNews(setNewsArticles)
    }, [])



    return (<>
        <div className={classes.container}>
            <div>
                <h3>Info Flow</h3>
            </div>

            <div className={classes.container1}>
                {newsArticles.length === 0 ? (

                    <h3>No News</h3>
                ) : newsArticles.map((news, index) => (
                    <div className={``}style={{backgroundColor: `${index % 2 == 0 ? colors.Dark : colors.Light}`}}>
                        <div className="d-flex justify-content-between align-items-center p-3">
                            <a href={news["public_data_source_url"]}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={classes.link}
                                title={news["public_data_source_url"]}>
                                {news["document_name"]}
                            </a>
                            <div className="text-right">
                                {new Date(news["publication_timestamp"]).toLocaleDateString()}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>





    </>

    )
}

export default InfoFlowTile
